import React from 'react';
import Table from 'react-bootstrap/Table';

class WidgetTable extends React.Component {

  render() {
    const table = 
      <Table striped bordered hover>
        <thead>
          {
            this.props.table.filter((item, i) => i === 0).map((row, i) => (
              <tr key={`body_${i}`}>
                {row.map((item, j) => (
                  <th key={`body_${i}_${j}`}>
                    {item}
                  </th>
                ))}
              </tr>
            ))
          }
        </thead>
        <tbody className="listlead">
          {
            this.props.table.filter((item, i) => i !== 0).map((row, i) => (
              <tr key={`body_${i}`}>
                {row.map((item, j) => (
                  <td key={`body_${i}_${j}`}>
                    {item}
                  </td>
                ))}
              </tr>
            ))
          }
        </tbody>
      </Table>;
    return(
      <div className={this.props.widget.x ? 'col-md-6' : 'col-md-3'}>
        <div><h5>{this.props.widget.name}</h5></div>
        {table}
      </div>);
  }
}
export default WidgetTable;